import React, { useState, useEffect } from 'react'

import { Button, Drawer, Message, Panel, Placeholder, Table } from 'rsuite'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'
import pathname from '../../constants/pathname'
import { contractChangeHistoy } from '../../redux/actions/contract'
import HTMLWidget from '../HTMLWidget'
import { Link } from 'react-router-dom/cjs/react-router-dom'
import CancelButton from '../../components/buttons/cancelButton/CancelButton'
import { DEFAULT_ERR_MSG } from '../../constants/msgText'

export default function ContractChangeHistoryWidget({ projectId, ...props }) {
  const { Column, HeaderCell, Cell } = Table
  const { Paragraph } = Placeholder

  const history = useHistory()

  const [error, setError] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [formSchema, setFormSchema] = useState()
  const [detail, setDetail] = useState()

  useEffect(() => {
    if (projectId) {
      handleGetSchema(projectId)
    }
  }, [])

  const handleGetSchema = async (projectId) => {
    setIsLoading(true)

    try {
      const response = await contractChangeHistoy(projectId)
      // console.log('response => ', response)
      //let response = mock
      if (response) {
        setFormSchema(response)
      }
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    setIsLoading(false)
  }

  const stripHtmlTags = (str) => {
    if (!str) return ''
    return str.replace(/<\/?[^>]+(>|$)/g, '') // ลบแท็ก <... ออกไปให้หมด
  }

  return (
    <>
      {(formSchema || error) && (
        <Panel
          shaded
          header={formSchema?.header || 'ประวัติการขอแก้ไขข้อตกลงอื่นๆ'}
          collapsible
          defaultExpanded
        >
          {error && !isLoading && !formSchema && (
            <Message
              showIcon
              type="error"
              description={`${error.errorMessage || DEFAULT_ERR_MSG} CODE: ${error.statusCode || 500}`}
            />
          )}

          {formSchema && !isLoading && (
            <Table
              autoHeight
              wordWrap
              bordered
              data={formSchema?.datas || []}
              style={{ marginBottom: 10 }}
            >
              <Column width={100} align="center">
                <HeaderCell>ครั้งที่</HeaderCell>
                <Cell dataKey="seq" />
              </Column>
              <Column width={450} minWidth={450} flexGrow={1}>
                <HeaderCell>รายละเอียดการขอแก้ไข</HeaderCell>
                {/* <Cell dataKey="desc" /> */}
                <Cell>
                  {(rowData) => {
                    const rawText = stripHtmlTags(rowData?.description)
                    const isTooLong = rawText.length > 100 // เช็คว่าข้อความจริงเกิน 300 ไหม

                    return (
                      <div style={{ height: 51 }}>
                        <span>{rawText?.substring(0, 100)}</span>
                        {isTooLong && (
                          <Link
                            onClick={() => {
                              setDetail(rowData?.description)
                            }}
                          >
                            ... แสดงเพิ่มเติม
                          </Link>
                        )}
                      </div>
                    )
                  }}
                </Cell>
              </Column>
              <Column width={180} align="center">
                <HeaderCell>วันที่ขอแก้ไข</HeaderCell>
                <Cell dataKey="requestDate" />
              </Column>
              <Column width={180} align="center">
                <HeaderCell>วันที่อนุมัติ</HeaderCell>
                <Cell dataKey="approvedDate" />
              </Column>
            </Table>
          )}
        </Panel>
      )}

      <Drawer
        full
        placement={'top'}
        show={detail}
        onHide={() => {
          setDetail()
        }}
      >
        <Drawer.Header>
          <Drawer.Title></Drawer.Title>
        </Drawer.Header>
        <Drawer.Body>
          <div
            style={{ maxHeight: '90vh', overflow: 'scroll', cursor: 'pointer' }}
            dangerouslySetInnerHTML={{ __html: detail }}
          />
        </Drawer.Body>
        <Drawer.Footer>
          <div style={{ paddingBottom: 20 }}>
            <CancelButton children="ปิด" onClick={() => setDetail('')} />
          </div>
        </Drawer.Footer>
      </Drawer>
    </>
  )
}

// const mock = {
//   header: 'ประวัติการขอแก้ไขข้อตกลงอื่นๆ',
//   datas: [
//     {
//       seq: '3',
//       desc: 'บทความ (Article) คือ งานเขียนที่เผยแพร่ผ่านสื่อสิ่งพิมพ์หรือสื่อดิจิทัล โดยมีวัตถุประสงค์เพื่อเผยแพร่ความรู้ ข่าวสาร แสดงความคิดเห็น หรือวิเคราะห์เรื่องใดเรื่องหนึ่งอย่างเจาะลึก มักประกอบด้วย หัวข้อ (Title), บทนำ (Introduction), เนื้อหาหลัก (Body) และบทสรุป (Conclusion) \r\n บทความ (Article) คือ งานเขียนที่เผยแพร่ผ่านสื่อสิ่งพิมพ์หรือสื่อดิจิทัล โดยมีวัตถุประสงค์เพื่อเผยแพร่ความรู้ ข่าวสาร แสดงความคิดเห็น หรือวิเคราะห์เรื่องใดเรื่องหนึ่งอย่างเจาะลึก มักประกอบด้วย หัวข้อ (Title), บทนำ (Introduction), เนื้อหาหลัก (Body) และบทสรุป (Conclusion)',
//       requestDate: '10/10/2025',
//       apppoveDate: '10/10/2025',
//     },
//     { seq: '2', desc: 'ddd', requestDate: '10/10/2025', apppoveDate: '10/10/2025' },
//     { seq: '1', desc: 'หำำำไ', requestDate: '10/10/2025', apppoveDate: '10/10/2025' },
//   ],
// }
